import { React, styled } from 'x'
import { Link } from 'common'

export const A = styled(Link)`
  color: #fff;
`

export const H1 = styled.h1`
  margin: 0 0 10px 0;
  color: #f5f5f5;
  padding-top: 18px;
  padding-bottom: 18px;
`

export const H2 = styled.h2`
  margin: 0;
  color: #fff;
  font-weight: 500;
  font-size: 28px;
  line-height: 36px;
  letter-spacing: 0.05em;
  padding-top: 18px;
  padding-bottom: 12px;
  font-family: 'Dosis', Helvetica, Arial, sans-serif;
  font-feature-settings: 'ss03';
`

export const H3 = styled.h3`
  margin: 0;
  color: #fff;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0.05em;
  padding-top: 6px;
  font-family: 'Dosis', Helvetica, Arial, sans-serif;
  font-feature-settings: 'ss03';
`

export const H4 = styled.h4`
  margin: 0 0 10px 0;
  color: #fff;
`

export const H5 = styled.h5`
  margin: 0 0 10px 0;
  color: #fff;
`

export const H6 = styled.h6`
  margin: 0 0 10px 0;
  color: #fff;
`

export const Paragraph = styled.p`
  color: #dcdcdc;
  line-height: 27px;
`

export default {
  a: A,
  h1: H1,
  h2: H2,
  h3: H3,
  h4: H4,
  h5: H5,
  h6: H6,
  p: Paragraph,
}
